import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EnrollFormModal from "../pages/EnrollFormModal";
import "../styles/CourseOffered.css";
import { fetchCourses } from "../API/API";

const defaultCourses = [
  {
    id: 1,
    course: 1,
    title: "Data Science",
    course_duration: "12 Weeks",
    educator_name: "Mr. Manikonda Sharat",
    educator_profile: "/images/datasci.png",
    link: "https://example.com/enroll/datasci",
    syllabusLink: "https://example.com/syllabus/datasci.pdf"
  },
  {
    id: 2,
    course: 2,
    title: "Data Analytics",
    course_duration: "14 Weeks",
    educator_name: "Mr. Manikonda Sharat",
    educator_profile: "/images/datalns.png",
    link: "https://example.com/enroll/data-analytics",
    syllabusLink: "https://example.com/syllabus/data-analytics.pdf"
  },
  {
    id: 3,
    course: 3,
    title: "Data Analytics",
    course_duration: "14 Weeks",
    educator_name: "Deepak .B",
    educator_profile: "/images/datalns.png",
    link: "https://example.com/enroll/data-analytics-deepak",
    syllabusLink: "https://example.com/syllabus/data-analytics-deepak.pdf"
  },
  {
    id: 4,
    course: 4,
    title: "Data Engineering",
    course_duration: "12 Weeks",
    educator_name: "Manikonda Sharat",
    educator_profile: "/images/dataeng.png",
    link: "https://example.com/enroll/dataeng",
    syllabusLink: "https://example.com/syllabus/dataeng.pdf"
  },
  {
    id: 5,
    course: 5,
    title: "Generative AI and Prompt Engineering",
    course_duration: "8 Weeks",
    educator_name: "Mr. Manikonda Sharat",
    educator_profile: "/images/genai.png",
    link: "https://example.com/enroll/genai",
    syllabusLink: "https://example.com/syllabus/genai.pdf"
  },
  {
    id: 8,
    course: 8,
    title: "Machine Learning Engineering",
    course_duration: "8 Weeks",
    educator_name: "Manikonda Sharat",
    educator_profile: "/images/MLEngg3.png",
    link: "https://example.com/enroll/ml",
    syllabusLink: "https://example.com/syllabus/mle.pdf"
  }
];

const CourseOffered = ({ context, trainer }) => {
  const [courses, setCourses] = useState([]);
  const [showEnrollForm, setShowEnrollForm] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const isTrainerPage = context === "trainer";

  const loadCourses = useCallback(() => {
    fetchCourses()
      .then((res) => {
        let allCourses =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data
            : defaultCourses;

        allCourses = allCourses.map((course) => ({
          ...course,
          id: Number(course.id) || course.id,
        }));

        if (isTrainerPage && trainer?.name) {
          allCourses = allCourses.filter((course) =>
            course.educator_name?.toLowerCase().includes(trainer.name.toLowerCase())
          );
        }

        if (!isTrainerPage) {
          const seenTitles = new Set();
          allCourses = allCourses.filter((course) => {
            if (seenTitles.has(course.title.toLowerCase())) return false;
            seenTitles.add(course.title.toLowerCase());
            return true;
          });
        }

        setCourses(allCourses);
      })
      .catch(() => {
        let fallback = defaultCourses;

        if (isTrainerPage && trainer?.name) {
          fallback = fallback.filter((course) =>
            course.educator_name?.toLowerCase().includes(trainer.name.toLowerCase())
          );
        }

        if (!isTrainerPage) {
          const seenTitles = new Set();
          fallback = fallback.filter((course) => {
            if (seenTitles.has(course.title.toLowerCase())) return false;
            seenTitles.add(course.title.toLowerCase());
            return true;
          });
        }

        setCourses(fallback);
      })
      .finally(() => setLoading(false));
  }, [isTrainerPage, trainer]);

  useEffect(() => {
    loadCourses();
  }, [context, trainer, loadCourses, isTrainerPage]);

  return (
    <div className="course-offered" style={{ position: "relative" }}>
      <div className="top-enroll-container">
        <button className="top-enroll-btn" onClick={() => setShowEnrollForm(true)}>
          Enroll
        </button>
      </div>

      <EnrollFormModal isOpen={showEnrollForm} onClose={() => setShowEnrollForm(false)} />

      <div className={isTrainerPage ? "trainer-course-container" : "courses-container"}>
        <h2 className={isTrainerPage ? "course-offered-title" : "section-title"}>
          {isTrainerPage && trainer ? `Courses by ${trainer.name}` : "Courses We Offer"}
        </h2>

        {loading ? (
          <p>Loading courses...</p>
        ) : courses.length === 0 ? (
          <p>No courses found{trainer?.name ? ` for ${trainer.name}` : ""}.</p>
        ) : (
          <div className={isTrainerPage ? "courses-wrapper" : "course-grid"}>
            {courses.map((course) => (
              <div
                className={isTrainerPage ? "course-card-vertical" : "course-card"}
                key={course.id}
              >
                <img
                  src={course.educator_profile}
                  alt={course.title}
                  className="course-image"
                />

                <div className="course-text">
                  <h3 className="course-name">{course.title}</h3>
                  {isTrainerPage && (
                    <span className="course-expert">By {course.educator_name}</span>
                  )}
                </div>
                <span className="course-duration" id="course-duration1">
                  {course.course_duration}
                </span>

                <div className="course-meta">
                  <button
                    className="enroll-button"
                    onClick={() =>
                      navigate(`/courses?program=${encodeURIComponent(course.title)}`)
                    }
                    disabled={!course.syllabusLink}
                  >
                    View Syllabus
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseOffered;
